module.exports = __webpack_public_path__ + "static/media/Spring-Cleaning_Booking-Form_header.0ceb4722.png";